export const planData = [
  {
    id: 0,
    name: 'Start',
    period: 'mês',
    price: 247.00,
    price_description: '25% de desconto no plano anual',
    description: 'Perfeito para dar os primeiros passos e automatizar tarefas',
    features: [
      '3 Agentes de IA',
      '500 conversas/mês',
      'Integração com WhatsApp',
      'Suporte via comunidade',
    ],
    recommended: true,
  },
  {
    id: 1,
    name: 'Growth',
    period: 'mês',
    price: 637.00,
    price_description: '25% de desconto no plano anual',
    description: 'Para negócios em crescimento que buscam mais poder',
    features: [
      '9 Agentes de IA',
      '1.700 conversas/mês',
      'Integrações Avançadas',
      'Dashboard de Análise',
      'Suporte Prioritário via Email',
    ],
    recommended: false,
  },
]
